export const LabelWithAsteriskMark = ({style, label, isAsteriskMark = true }) => {
    return (
        <span style={{ whiteSpace: 'nowrap',...style }}>{label}{isAsteriskMark && (<span style={{ color: 'red' }}> *</span>)}</span>
    )
}